import React, {createContext, useEffect, useState} from "react";
import {role} from "~/components/pages/settings/roles/constants";
import {convertPermissions} from "./helpers/convertPermissions";
import {useSideBarMenuItems} from "~/components/context/userContext/hooks/useSideBarMenuItems";
import {validateEnumType} from "~/components/context/userContext/helpers/validateType";
import {types} from "~/components/context/userContext/helpers/types";
import {usersApi} from "~/api/dashboard/usersApi";

export const UserContext = createContext();

export const UserProvider = ({children}) => {
    const accessToken = localStorage.getItem("accessToken");

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [permissionActionsList, setPermissionActionsList] = useState({});

    const { sideBarMenuItems } = useSideBarMenuItems(permissionActionsList)

    const getSectionsPermissions = (product) => {
        if (Object.keys(permissionActionsList).length > 0) {
            validateEnumType(product, types?.products)
        }
        if (permissionActionsList && permissionActionsList[product]) {
            return permissionActionsList[product];
        }
    };

    const fetchUserData = async () => {
        try {
            const result = await usersApi.profile();
            if (result?.data) {
                setUser(result.data.data);
                setPermissionActionsList(convertPermissions(role.tradeAssistantPermissions))
            } else if (result.error) setError(result.error);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching user data:", error);
            setError(error);
            setLoading(false);
        }
    };


    const updateUser = (newUser) => {
        setUser(newUser);
    };

    useEffect(() => {
        if (accessToken && accessToken.length > 0) fetchUserData();
    }, [accessToken]);



    const permissionsValues = {
        sideBarMenu: sideBarMenuItems,
        getSectionsPermissions,
        perActions: permissionActionsList
    }
    return (
        <UserContext.Provider value={{ user, loading, error, updateUser ,permissionsValues}}>
            {children}
        </UserContext.Provider>

    );
};
